export default __webpack_public_path__ + "static/media/import-export.ceb27ef3.svg";